<template>
  <modal-form
    v-slot="{ properties, errors, entity }"
    type="editPaymentTerminal"
    :options="{
      properties: {
        name: '',
        ipAddress: '',
        interfaceType: null,
        store: null,
      },
      postUri: '/payment_terminals',
      label: $t('paymentTerminal.label')
    }"
  >
    <fancy-input v-model="properties.name" :label="$t('general.field.name')" :error="errors.name" required />
    <fancy-input v-model="properties.ipAddress" :label="$t('general.field.ipAddress')" :error="errors.ipAddress" required />
    <simple-dropdown
      v-model="properties.interfaceType"
      :options="interfaceTypeOptions"
      :label="$t('paymentTerminal.interfaceType.label')"
      :error="errors.interfaceType"
      required
    />
    <multiselect
      v-if="entity['@id']"
      v-model="properties.store"
      :options="async (q) => loadStoreOptions(q, properties.store)"
      :loading="loadingStoreOptions"
      :error="errors.store"
      :form-label="$t('store.label')"
      :filter-results="false"
      searchable
    />
  </modal-form>
</template>
<script>
import { useI18n } from 'vue-i18n';
import ModalForm from '@/components/shared/ModalForm.vue';
import FancyInput from '@/components/utils/forms/FancyInput.vue';
import Multiselect from '@/components/utils/forms/Multiselect.vue';
import SimpleDropdown from '@/components/utils/forms/SimpleDropdown.vue';
import useLoadOptions from '@/hooks/api/loadOptions';
import { PAYMENT_TERMINAL_INTERFACE_TYPES } from '@/constants';

export default {
  name: 'EditPaymentTerminalModal',
  components: {
    FancyInput,
    ModalForm,
    Multiselect,
    SimpleDropdown,
  },
  setup() {
    const { t } = useI18n();
    const {
      loadOptions: loadStoreOptions,
      loading: loadingStoreOptions,
    } = useLoadOptions('/stores', 'name');

    const interfaceTypeOptions = Object.entries(PAYMENT_TERMINAL_INTERFACE_TYPES)
      .map(([key, value]) => ({ key, label: t(`paymentTerminal.interfaceType.${key}`), value }));

    return {
      loadStoreOptions,
      loadingStoreOptions,
      interfaceTypeOptions,
    };
  },
};
</script>
